import { environment } from "../../../environments/environment";

const TEST_API_HOSTS = ["juchating-dev-api.kncuration.net"];

/** 앱 TestServerBanner와 동일 기준: 테스트 API에 연결된 경우 true */
export function isTestServer(): boolean {
  const apiUrl = environment.apiUrl || "";
  if (!apiUrl) {
    return false;
  }

  try {
    const host = new URL(apiUrl).host;
    return TEST_API_HOSTS.includes(host);
  } catch {
    return apiUrl.includes("juchating-dev-api");
  }
}
